import { BrowserRouter as Router } from "react-router-dom"; // WICHTIG
import "./components/MainStart.css";
import Navbar from "./components/ui/NavbarStart.jsx";
import LandingPageStart from "./components/pages/LandingPageStart.jsx";

function App() {
  return (
    <Router> {/* Alles muss innerhalb des Routers liegen */}
      <div className="app-layout">
        <Navbar />
        <main className="app-content">
          <LandingPageStart />
        </main>
      </div>
    </Router>
  );
}

export default App;